import type { ITranslationLanguage } from '../challenges/enums/translation-language';

export const LANGUAGE_SLUG_BY_CODE: Record<ITranslationLanguage, string> = {
  zh: 'mandarin-chinese',
  hi: 'hindi',
  es: 'spanish',
  fr: 'french',
  ar: 'arabic',
  bn: 'bengali',
  pt: 'portuguese',
  ru: 'russian',
  ur: 'urdu',
  de: 'german',
  fa: 'persian',
  it: 'italian',
};

export const LANGUAGE_CODE_BY_SLUG: Record<string, ITranslationLanguage> = Object.fromEntries(
  Object.entries(LANGUAGE_SLUG_BY_CODE).map(([code, slug]) => [slug, code as ITranslationLanguage]),
) as Record<string, ITranslationLanguage>;
